import { Password } from '../Shared/password'

export const Login = () => {
    const render = () => {
        Password({ eyeIconSelector: ".eyeicon", passInputSelector: ".passwordinput" });
    }

    render()
}